import { NETWORKS } from "../providers";

export function resolveNetworkEndpoint(network: string): string {
  const endpoint = NETWORKS[network as keyof typeof NETWORKS];
  if (!endpoint) {
    throw new Error(
      `Unknown network: ${network}. Valid networks: ${Object.keys(NETWORKS).join(", ")}`
    );
  }
  return endpoint;
}

export function isValidNetwork(network: string): boolean {
  return network in NETWORKS;
}

export function getAvailableNetworks(): string[] {
  return Object.keys(NETWORKS);
}
